import { useState } from 'react';

export default function SelectionForm() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const data = new URLSearchParams();
    formData.forEach((value, key) => {
      data.append(key, value.toString());
    });
    
    try {
      await fetch('https://readdy.ai/api/form/d5j484qgbpr25eot443g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: data.toString()
      });
      setFormStatus('success');
      e.currentTarget.reset();
      setTimeout(() => setFormStatus('idle'), 5000);
    } catch {
      setFormStatus('error');
      setTimeout(() => setFormStatus('idle'), 5000);
    }
  };

  return (
    <section id="selection" className="py-12 sm:py-16 bg-gray-50">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-10">
        <div className="max-w-[600px] mx-auto text-center mb-8 sm:mb-10">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">Подбор оборудования по техническому заданию</h2>
          <p className="text-sm sm:text-base text-gray-600">
            Подберём оборудование под ваши параметры: груз, высота, режим работы, условия эксплуатации, тип балки.
          </p>
        </div>

        <form 
          data-readdy-form
          onSubmit={handleSubmit}
          className="max-w-[480px] mx-auto space-y-5"
        >
          <input
            type="text"
            name="company"
            placeholder="Компания"
            required
            className="w-full h-12 px-3 border border-gray-300 text-[15px] focus:outline-none focus:border-[#1A2B4A] bg-white"
          />
          <input
            type="text"
            name="contact"
            placeholder="Контактное лицо"
            required
            className="w-full h-12 px-3 border border-gray-300 text-[15px] focus:outline-none focus:border-[#1A2B4A] bg-white"
          />
          <input
            type="tel"
            name="phone"
            placeholder="Телефон"
            required
            className="w-full h-12 px-3 border border-gray-300 text-[15px] focus:outline-none focus:border-[#1A2B4A] bg-white"
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            required
            className="w-full h-12 px-3 border border-gray-300 text-[15px] focus:outline-none focus:border-[#1A2B4A] bg-white"
          />
          <textarea
            name="description"
            placeholder="Краткое описание задачи"
            required
            maxLength={500}
            rows={5}
            className="w-full px-3 py-3 border border-gray-300 text-[15px] focus:outline-none focus:border-[#1A2B4A] resize-none bg-white"
          />
          <button 
            type="submit"
            className="w-full bg-[#1A2B4A] text-white h-[48px] sm:h-[52px] text-sm sm:text-base font-medium hover:bg-[#0F1A2E] transition-colors whitespace-nowrap cursor-pointer"
          >
            Отправить запрос
          </button>

          {formStatus === 'success' && (
            <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 text-sm">
              Спасибо! Ваш запрос отправлен. Мы свяжемся с вами в ближайшее время.
            </div>
          )}
          {formStatus === 'error' && (
            <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 text-sm">
              Произошла ошибка. Пожалуйста, попробуйте позже.
            </div>
          )}
        </form>
      </div>
    </section>
  );
}